import { Box, Typography, Dialog, IconButton } from '@mui/material';
import { useEffect, useState } from 'react';
import { ConductionButtonsComponent } from '../../components/composites/ConductionButtonsComponent';
import PrimaryButton from '../../components/elements/PrimaryButton';
import { pxToRem, pxTovW } from '../../commonUtils/resizeUtils';
import ImageWrapper from '../../components/elements/ImageWrapper';

export const ConductionButtonsComponentDocs = () => {
  const [open, setOpen] = useState(false);
  const [selected, setSelected] = useState<number>();
  return (
    <Box sx={{ width: '60%', m: 'auto' }}>
      <PrimaryButton
        onClick={() => {
          setOpen(true);
        }}
      >
        <Typography variant="h1" color="success.light">
          Open Popup
        </Typography>
      </PrimaryButton>
      selected: {selected}
      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        maxWidth="md"
        sx={{
          '& .MuiDialog-paper': {
            // position: 'absolute',
            // top: '10%',
            borderRadius: '20px',
            background: 'transparent',
            border: '0px solid transparent',
            boxShadow: 'none',
            width: '100%',
            maxWidth: { xs: '100%', md: pxTovW(1000), lg: pxTovW(900) },
            // height: '495px',
            '@media (max-width:600px)': {
              width: '100%', // Adjust width for extra-large screens (lg and above)
            },
          },
        }}
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: 'flex-start',
            flexDirection: { xs: 'column', md: 'row' },
            gap: { xs: pxToRem(10), md: pxTovW(23) },
          }}
        >
          <Box
            sx={{
              borderRadius: '20px',
              background: 'white',
              padding: {
                xs: `${pxToRem(17)} ${pxToRem(20)}`,
                md: `${pxTovW(35)} ${pxTovW(48)}`,
                lg: `${pxTovW(35)} ${pxTovW(48)}`,
              },
              width: '100%',
              maxWidth: {
                xs: `calc(100% - ${pxToRem(40)})`,
                md: `calc(100% - ${pxTovW(116)})`,
                lg: `calc(100% - ${pxTovW(116)})`,
              },
              display: 'flex',
              flexDirection: 'column',
              gap: { xs: pxToRem(24), md: pxToRem(55) },
              alignItems: 'center',
              marginX: 'auto',
            }}
          >
            <Typography variant="h6" mb={2}>
              Choose an Option:
            </Typography>

            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
              }}
            >
              <ConductionButtonsComponent
                value="mobile-app"
                onChange={(val: any) => setSelected(val)}
              />
              <Box sx={{ width: '230px', marginTop: '16px' }}>
                <PrimaryButton disabled={!selected}>Submit</PrimaryButton>
              </Box>
            </Box>
          </Box>

          <IconButton
            color="inherit"
            onClick={() => {
              setOpen(false); // also fixed the typo "flase"
            }}
            sx={{
              marginX: 'auto',
            }}
          >
            <ImageWrapper
              name="close-yellow"
              type="png"
              parentFolder="icons"
              styles={{
                top: '10%',
                width: '33px',
                height: '33px',
              }}
            />
          </IconButton>
        </Box>
      </Dialog>
    </Box>
  );
};
